import React from "react";
import "./PillButton.scss";

export type PillButtonColor = "success" | "secondary" | "neutral" | "glass" | "glass-active" | "outline" | "primary";

export interface PillButtonProps {
  text: string;
  color?: PillButtonColor;
  onClick?: () => void;
  disabled?: boolean;
}

const PillButton: React.FC<PillButtonProps> = ({
  text,
  color = "success",
  onClick,
  disabled = false,
}) => {
  return (
    <div className="pill-button--wrapper">
      <button
        className={`pill-button pill-button--${color}`}
        onClick={onClick}
        disabled={disabled}
        style={{ maxWidth: "550px" }}
      >
        {text}
      </button>
    </div>
  );
};

export default PillButton;
